import React from "react";
import { Table } from "reactstrap";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import "./FormsTable.scss";

const StyledTableContainer = styled.div`
  width: 100%;
  padding: 1em;
  overflow-x: auto; /* Allows horizontal scroll if necessary */
`;

const StyledTable = styled(Table)`
  width: 100%;
  table-layout: fixed;
  background-color: transparent;
  border-radius: 16px 16px 0px 0px;
  overflow: hidden;
  table-layout: fixed;

  & thead {
    background-color: #f8f9fa;
  }

  & td {
    padding: 1em;
    text-align: left;
    font-size: 14px;
    font-weight: 500;
    border: none; /* Remove all borders */
    border-bottom: 1px solid #dee2e6; /* Only keep the bottom border */
    vertical-align: middle;
    background-color: white; /* Ensure the background is white */
    white-space: normal;
  }
  
  & th {
    padding: 1em;
    text-align: left;
    border: none;
    border-bottom: 1px solid #dee2e6;
    white-space: normal;
  }
`;

const MilestoneNameCell = styled.td`
  min-width: 200px;
  
  & a {
    display: block;
    text-decoration: none;
    color: #2e7d32;
  }

  & .arrow-icon {
    display: inline-block;
    margin-right: 4px;
    
    @media (max-width: 992px) {
      display: none;
    }
  }
`;

function FormsTable({ forms }) {
  return (
    <StyledTableContainer>
      <StyledTable className="custom-table">
        <colgroup>
          <col style={{ width: "10%" }} />
          <col style={{ width: "30%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "12%" }} />
          <col style={{ width: "8%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
          <col style={{ width: "10%" }} />
        </colgroup>
        <thead className="table-header">
          <tr>
            <th scope="col">Location</th>
            <th scope="col">Milestone Name</th>
            <th scope="col">System</th>
            <th scope="col">Status</th>
            <th scope="col">Average Score</th>
            <th scope="col">Owner</th>
            <th scope="col">Supervisor</th>
            <th scope="col">Updated At</th>
          </tr>
        </thead>
        <tbody>
          {forms && forms.length > 0 ? (
            forms.map((row, i) => {
              const status = row.is_complete
                ? row.approved_by_supervisor
                  ? "Complete and Approved"
                  : "Complete but Pending Approval"
                : "Incomplete";

              const averageScore =
                row.average_score !== null ? row.average_score.toFixed(2) : "";

              const owner = row.owner_and_supervisor?.owner
                ? `${row.owner_and_supervisor.owner.first_name} ${row.owner_and_supervisor.owner.last_name}`
                : "";

              const supervisor = row.owner_and_supervisor?.supervisor
                ? `${row.owner_and_supervisor.supervisor.first_name} ${row.owner_and_supervisor.supervisor.last_name}`
                : "";

              return (
                <tr key={i}>
                  <td style={{ color: "#4D4D4D" }}>{row?.country?.long_name || ""}</td>
                  <MilestoneNameCell>
                    <Link
                      to={`/system-forms/${row.country_id}/${row.milestone_id}`}
                      title={row?.benchmarking_milestone?.name || ""}
                    >
                      <span className="arrow-icon">↗</span> 
                      <span className="milestone-text">{row?.benchmarking_milestone?.name || ""}</span>
                    </Link>
                  </MilestoneNameCell>
                  <td>{row?.benchmarking_milestone?.system?.name || ""}</td>
                  <td>{status}</td>
                  <td>{averageScore}</td>
                  <td>{owner}</td>
                  <td>{supervisor}</td>
                  <td>{row.updated_at}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="8">No data available</td>
            </tr>
          )}
        </tbody>
      </StyledTable>
    </StyledTableContainer>
  );
}

export default FormsTable;